import { Grid, Menu } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';

import { SyntheticEvent, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import ChartData from '../Charts/ChartData';
import DashboardProdPlanTable from '../DashboardContainer/DashboardProdPlanTable';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import NFAIRestorationDashboard from '../../NFAIRestorationDashboard';
import { initialPostFilteredItemDetails, PostFilteredItemDetailsTypes } from '../../../app/models/metaDataConfig';

function StepL2ForPlanning() {
  const {
    activityStore,
    dashboardStore,
    commonStore,
    userStore: { user },
  } = useStore();

  const {
    activitiesAll,
    loadProduction,
    typeProduction,
    loadProductionTask,
    taskTypeProduction,
    loadProductionPagination,
  } = activityStore;
  const { showDashboardReport } = dashboardStore;

  const [getItemType, setGetItemType] = useState<any>([]); //for count for each type  //Film:5
  const [getTaskType, setGetTaskType] = useState<any>({}); //task type and count
  const [tabItemLen] = useState<any>();
  const [tabTaskLen, setTabTaskLen] = useState<any>();
  const [showL2Step, setShowL2Step] = useState<boolean>(false);
  const [activeType, setActiveType] = useState<any>();
  const [activeType2, setActiveType2] = useState<any>();
  const [gettaskcount, setGetttaskcount] = useState(0);

  useEffect(() => {
    // Split Item type
    loadProduction(); //api call to list data
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    let newObj: {
      count: number;
      task: string;
    }[] = [];
    // eslint-disable-next-line
    typeProduction.map((x: any) => {
      newObj.push(x);
    });
    setGetItemType(typeProduction);
    if (!typeProduction?.length) return;
    loadProductionTask(typeProduction[0].task);
    setActiveType(typeProduction[0].task);
    dashboardStore.openL2ForPlanning(typeProduction[0].task);
    dashboardStore.dashboard.setProductionType = typeProduction[0].task;
    setShowL2Step(true);
    // eslint-disable-next-line
  }, [typeProduction]);

  useEffect(() => {
    if (!activeType) return;
    activityStore.setTask(activeType);
   // eslint-disable-next-line
  }, [activeType]);

  useEffect(() => {
    let newObj: any = {};
    taskTypeProduction.forEach((x: any) => {
      Object.assign(newObj, { [x.subtask]: x.count });
    });
    setGetTaskType(newObj);
    setActiveType2(Object.keys(newObj)[0]);
    setGetttaskcount(Object.values(newObj)[0] as number);
    // eslint-disable-next-line
  }, [taskTypeProduction]);

  useEffect(() => {
    if (activeType2) {
      activityStore.addSubTask(activeType2);
      if (
        typeProduction.length > 0 &&
        dashboardStore.dashboard.setProductionType === ''
      ) {
        if(commonStore.NFAIReportCustomer){ 
          const dashboard = dashboardStore.dashboard;
           dashboard.setTagTablePageNumber = 1;
                const payload:PostFilteredItemDetailsTypes = {
                ...initialPostFilteredItemDetails,
                title: '',
                currentTask: activeType || '',
                currentSubtask: activeType2 || '',
                status: '',
                Previoustask: '',
                PreviousSubtask: '',
              }
              activityStore.NFAIRestorationProductionPlanningSearch(payload);
        } else loadProductionPagination(typeProduction[0].Type, activeType2, 1); //set the type and task
        dashboardStore.dashboard.prodPlanTableLength = typeProduction[0].Count; //count data

        dashboardStore.dashboard.setProductionType = typeProduction[0].Type;
        dashboardStore.dashboard.setProductionTask = activeType2;
      }
      if (
        typeProduction.length > 0 &&
        dashboardStore.dashboard.setProductionType !== ''
      ) {
        if(commonStore.NFAIReportCustomer){ 
          const dashboard = dashboardStore.dashboard;
           dashboard.setTagTablePageNumber = 1;
                const payload:PostFilteredItemDetailsTypes = {
                ...initialPostFilteredItemDetails,
                title: '',
                currentTask: activeType || '',
                currentSubtask: activeType2 || '',
                status: '',
                Previoustask: '',
                PreviousSubtask: '',
              }
              activityStore.NFAIRestorationProductionPlanningSearch(payload);
        } 
        else loadProductionPagination(
          dashboardStore.dashboard.setProductionType,
          activeType2,
          1,
        ); //set the type and task
        dashboardStore.dashboard.setProductionTask = activeType2;
        dashboardStore.dashboard.prodPlanTableLength = gettaskcount; //count data
      }
    }
    // eslint-disable-next-line
  }, [activeType2]);

  const openStep2 = (data: string, value: any) => {
    loadProductionTask(data);
    setGetttaskcount(value);
    dashboardStore.dashboard.prodPlanTableLength = parseInt(value);
    dashboardStore.dashboard.setProductionType = data;

    const filterType = activitiesAll?.filter(
      (itemType: any) =>
        data === itemType.type && itemType.isReceiving === true,
    );
    let taskDataFliter: any = [];
    filterType.forEach((data) => {
      if (data.current_task !== null && data.current_task !== undefined) {
        let taskTyp = data.current_task;
        taskTyp = taskTyp?.charAt(0)?.toUpperCase() + taskTyp?.slice(1);
        taskDataFliter = [...taskDataFliter, taskTyp];
      }
    });
    const counts: any = {};
    taskDataFliter?.forEach((data: any) => {
      if (data !== null) {
        counts[data] = taskDataFliter.filter(
          (taskType: any) => data === taskType,
        ).length;
      }
    });
    // setGetTaskType(counts);
    setActiveType(data);
    dashboardStore.openL2ForPlanning(data);
    setActiveType2('');
    setTabTaskLen(2);
    setShowL2Step(true);
    //calling API table
    // loadProductionPagination(data,data,1);
  };

  const openStep3 = (e: SyntheticEvent, data: string, value: any) => {
    setActiveType2(data);
    setGetttaskcount(value);
    dashboardStore.dashboard.prodPlanTableLength = parseInt(value);
    dashboardStore.dashboard.setProductionTask = data;
    // dashboard.hideAssetTable = false;
    showDashboardReport();
    // dashboardStore.openL3ForPlanning(data);
     if(commonStore.NFAIReportCustomer){ 
          const dashboard = dashboardStore.dashboard;
           dashboard.setTagTablePageNumber = 1;
                const payload:PostFilteredItemDetailsTypes = {
                ...initialPostFilteredItemDetails,
                title: '',
                currentTask: activeType || '',
                currentSubtask: activeType2 || '',
                status: '',
                Previoustask: '',
                PreviousSubtask: '',
              }
              activityStore.NFAIRestorationProductionPlanningSearch(payload);
        } else loadProductionPagination(
      dashboardStore.dashboard.setProductionType,
      data,
      1,
    ); //set the type and task
  };

  return (
    <div className="L2-level">
      <Menu
        size="small"
        widths={
          getItemType?.length === tabItemLen ? tabItemLen : getItemType?.length
        }
        attached="bottom"
      >
        {getItemType?.length === 0 && (
          <Menu.Item
            style={{
              borderRight: '1px solid #F0F0F0',
            }}
          >
            <h5> No active workflow</h5>
          </Menu.Item>
        )}
        {getItemType?.map((data: any, index: any) => {
          return (
            <Menu.Item
              key={index}
              className={
                activeType === data.task
                  ? 'inventorylevel2dark'
                  : 'inventorylevel2light'
              }
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgb(215, 235, 242) 40%, rgb(255, 255, 255) 50%)`,
                maxWidth: '300px',
                // width: "auto"
              }}
              onClick={() => openStep2(data.task, data.count)}
            >
              <h4>{data.task + ' (' + data.count + ')'}</h4>
            </Menu.Item>
          );
        })}
      </Menu>
   
      {dashboardStore.dashboard.L1CardValue === 'Production' &&
        dashboardStore.dashboard.L2CardValuePlanning !== '' &&
        dashboardStore.dashboard.valueForL3Planning === '' && (
          <>
            {showL2Step && (
              <Menu
                size="tiny"
                widths={
                  Object.keys(getTaskType).length === tabTaskLen
                    ? tabTaskLen
                    : Object.keys(getTaskType).length
                }
              >
                <>
                  {Object.keys(getTaskType).length === 0 && (
                    <Menu.Item
                      style={{
                        borderRight: '1px solid #F0F0F0',
                        // background: `linear-gradient(90deg, rgb(215, 235, 242) 40%, rgb(255, 255, 255) 50%)`,
                      }}
                    >
                      <h5
                      //No active workflow
                      >
                        {
                          (
                            userLanguage[0]
                              .AssetsViewItemLevelViewPageWorkflowStepper
                              .AVILVPWSL01 as any
                          )?.[`${commonStore.language.key}`]
                        }
                      </h5>
                    </Menu.Item>
                  )}
                </>
                {Object.entries(getTaskType).map(([key, value]) => (
                  <Menu.Item
                    key={key}
                    className={
                      activeType2 === key
                        ? 'inventorylevel2dark'
                        : 'inventorylevel2light'
                    }
                    // widths={(Object.keys(getTaskType).length === tabTaskLen) ? tabTaskLen : Object.keys(getTaskType).length}
                    style={{
                      borderRight: '1px solid #F0F0F0',
                      background: `linear-gradient(90deg, rgb(215, 235, 242) 40%, rgb(255, 255, 255) 50%)`,
                    }}
                    onClick={(e) => openStep3(e, key, value)}
                  >
                    <h5>{key + ' (' + value + ')'}</h5>
                  </Menu.Item>
                ))}
              </Menu>
            )}
            <Grid stackable>
              {(user?.customerName !== 'NFAI' ||
                window.innerWidth > 1025 ||
                window.innerWidth < 1020) && (
                <Grid.Row>
                  {commonStore.NFAIReportCustomer ? <></> : <ChartData />}
                </Grid.Row>
              )}
              <Grid.Row>
                <DashboardProdPlanTable
                  selectedType={activeType}
                  selectedTask={activeType2}
                />
              </Grid.Row>
            </Grid>
          </>
        )}
      {dashboardStore.dashboard.L1CardValue === 'Production' &&
        dashboardStore.dashboard.L2CardValuePlanning === '' &&
        dashboardStore.dashboard.valueForL3Planning === '' && (
          <Grid stackable>
            {(user?.customerName !== 'NFAI' ||
              window.innerWidth > 1025 ||
              window.innerWidth < 1020) && (
              <Grid.Row>
                {commonStore.NFAIReportCustomer ? <></> : <ChartData />}
              </Grid.Row>
            )}
            <Grid.Row>
             {commonStore.NFAIReportCustomer ? <NFAIRestorationDashboard/>:  <DashboardProdPlanTable
                selectedType={activeType}
                selectedTask={activeType2}
              />}
            </Grid.Row>
          </Grid>
        )}
    </div>
  );
}

export default observer(StepL2ForPlanning);
